export default "__VITE_ASSET__csL81HLd__"